export const GEO_GROUPS_LABELS = {
    name: 'Гео групи'
}